module.exports = __webpack_public_path__ + "img/03.3c76dfa9.png";